var ClickUrlType;
(function (ClickUrlType) {
    ClickUrlType[ClickUrlType["None"] = 0] = "None";
    ClickUrlType[ClickUrlType["Retailer"] = 1] = "Retailer";
    ClickUrlType[ClickUrlType["Store"] = 2] = "Store";
    ClickUrlType[ClickUrlType["Product"] = 3] = "Product";
    ClickUrlType[ClickUrlType["Search"] = 4] = "Search";
    ClickUrlType[ClickUrlType["Cart"] = 5] = "Cart";
    ClickUrlType[ClickUrlType["Voucher"] = 6] = "Voucher";
    ClickUrlType[ClickUrlType["Checkout"] = 7] = "Checkout";
})(ClickUrlType || (ClickUrlType = {}));
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- class is global at runtime; `typeof Mapping` in MappingType is type-only for this rule
class Mapping {
    /**
     * Replaces {SWN-<PROPNAME>} macros in url with the value for PROPNAME
     * @param url - The URL string containing macros to be replaced
     * @param replacements - Object containing property values to replace macros with
     * @returns The URL string with macros replaced by their corresponding values
     */
    static _replaceMacros(url, replacements = {}) {
        const props = ['PAGEID', 'IID', 'RFR', 'RFR2', 'LEADID'];
        for (let i = 0; i < props.length; i++) {
            if (replacements[props[i]])
                url = url.replace(`{SWN-${props[i]}}`, replacements[props[i]]);
        }
        return url;
    }
    /**
     * Maps cart product availability data from API response to Product object
     * @param product - Product object from API response
     * @param availability - Availability object from API response
     * @returns Product object with mapped properties
     */
    static _getProductAvailability(product, availability) {
        return {
            id: product.id,
            ean: product.gtin,
            name: product.title,
            img: product.imageUrl,
            thumbImgUrl: product.thumbnailImageUrl,
            pkg: product.packaging,
            containing: '', // product.containing,
            retailerPdtId: availability?._retailerProductId || '',
            url: '', // product.url,
            available: availability?.stockStatus === 'Available' || false,
        };
    }
    /**
     * Maps raw availability data from API response to structured Availability objects
     * @param avails - Array of raw availability objects from API response
     * @param replacements - Object containing property values to replace macros in URLs with
     * @returns Array of structured Availability objects with mapped properties
     */
    static mapAvailabilities(products = [], carts = [], replacements = {}) {
        const avails = [];
        const isBundle = player.data.isBundle;
        for (const cart of carts) {
            const store = cart.store, retailer = store.retailer, bundleProducts = isBundle ? products : [];
            for (const availability of cart.availabilities) {
                const leadid = uuid().replace(/-/g, ''), 
                // clickUrl is the add to cart url for the bundle
                // or the availability click url for the classic experience
                clickUrl = isBundle ? cart.addToCartUrl : availability.clickUrl, rawUrl = clickUrl ? this._replaceMacros(clickUrl, replacements) : '', product = isBundle
                    ? products[0] // take the first requested product for the bundle
                    : products.find(p => p.id === availability.productId // use product id matching first
                        || Array.isArray(p.gtins) && p.gtins.includes(availability.gtin)); // fallback to gtins matching (linked products)
                if (isBundle && avails.some(av => av.retailer.id === retailer.id)) {
                    // if retailer already exists, ignore it and jump to next
                    continue;
                }
                avails.push({
                    // product to show in the UI
                    product: this._getProductAvailability(product, availability),
                    // bundle products with their availability
                    bundleProducts: bundleProducts.map((product) => {
                        const availability = cart.availabilities.find((av) => av.productId === product.id);
                        return this._getProductAvailability(product, availability);
                    }),
                    retailer: {
                        id: retailer.id,
                        code: retailer.code,
                        name: retailer.name,
                        url: retailer.url,
                        logo: this._cleanUrl(retailer.subsidiary?.logo.url || retailer.logo.url),
                        logoId: retailer.subsidiary ? `${retailer.id}_${retailer.subsidiary._id}` : retailer.id,
                        affiliate: !!retailer._affiliate,
                        affiliatePrgId: retailer._affiliate?.programId,
                        isTiedHouseLaw: availability.isTiedHouseLaw,
                    },
                    store: {
                        id: store.id,
                        name: store.name,
                        location: {
                            address: store.localeInfo?.address,
                            zipCode: store.localeInfo?.zipCode,
                            city: store.localeInfo?.city,
                            latitude: store.localeInfo?.latitude,
                            longitude: store.localeInfo?.longitude,
                        },
                        amz: false, // store.isAmazonStore,
                        typologyId: store.subsidiary?._id,
                        opening: '', // store.openingHours,
                        homeDelivery: store.delivery,
                        homeDeliveryAll: false, // store.homeDeliveryAll,
                        collect: store.clickAndCollect,
                        drive: store._drive || false,
                        brick: store.brickAndMortar,
                        url: store.url,
                        gmapUrl: store.localeInfo?.googleMapsUrl,
                        distance: store.localeInfo?.distance,
                        phone: store.phoneNumber,
                        whatsapp: store.whatsappNumber,
                        tags: store._tags || null,
                        imgUrl: '', // store.imgUrl,
                        openingHours: this._parseOpeningHours(store.storeOpeningHoursSchema),
                        openingType: undefined, // store.openingType,  // open24?
                        appointmentUrl: store._appointmentUrl || '',
                    },
                    nearestStore: null,
                    price: {
                        canShow: availability._prok,
                        amount: isBundle ? cart.totalPrice.value : availability.price.value,
                        unitPrice: availability.price.value,
                        unitPriceLbl: '', // availability.price.currency,
                        refPrice: 0, // availability.referencePrice,
                        promo: false, // availability.promo,
                        promoType: 0, // availability.promoType,
                        promoLbl: '', // availability.promoLabel,
                        promoPct: 0, // availability.promoPercentage,
                        promoAmount: 0, // availability.promoAmount,
                        currency: availability.price.currency,
                    },
                    voucher: availability.voucher || null,
                    voucherNewPrice: availability.price.valueWithVoucher || 0,
                    priority: availability.priority || false,
                    cartUrl: availability.addToCartUrl?.replace('{SWN-LEADID}', leadid) || '',
                    rawClkUrl: rawUrl,
                    clkUrl: rawUrl ? rawUrl.replace('{SWN-LEADID}', leadid) : '',
                    clkUrlType: ClickUrlType[availability._clickUrlType],
                    clkUrlAffiliate: availability._isAffiliateClickUrl,
                    leadid: leadid,
                    lockdown: !!store._isLockedDown,
                    availableProducts: cart.availableProducts || 0,
                    requestedProducts: cart.requestedProducts || 0,
                });
            }
        }
        return avails;
    }
    /**
     * Splits opening hours values to show days and hours separately.
     * @param values - An array of strings representing opening hours.
     * @returns An array of arrays, where each sub-array contains the split day and hours, or null if no values are provided.
     */
    static _parseOpeningHours(values) {
        if (!values || values.length === 0)
            return undefined;
        return values.map(line => line.split(' '));
    }
    /**
     * Cleans a CloudImage URL by removing the CloudImage base URL and query parameters,
     * then decodes any URI-encoded characters in the remaining path.
     *
     * @param url - The CloudImage URL to clean.
     * @returns The cleaned image path, decoded of any URI encoding.
     */
    static _cleanUrl(url) {
        if (!url.startsWith(this.RESIZE_BASE_URL))
            return url;
        let cleanUrl = url.replace(this.RESIZE_BASE_URL, '');
        const idx = cleanUrl.indexOf('?');
        if (idx > -1) {
            cleanUrl = cleanUrl.substring(0, idx);
        }
        return decodeURIComponent(cleanUrl);
    }
}
Mapping.RESIZE_BASE_URL = 'https://img.static-swaven.com/v7/';
